import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../styles/addEditSubrightScreen.module.css";
import Select from "react-select";
import OrganizationBuilder from "../models/builders/OrganizationBuilder";
import FBSubrightBuilder from "../models/builders/FBSubrightBuilder";

const AddEditSubrightScreen = ({
  editSubright,
  addSubright,
  deleteSubright,
  selectedRightCategory,
  orgs,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const subright = location.state.subright;
  const editMode = location.state.editMode;
  const selectOptions =
    OrganizationBuilder.buildOrgArrWithValueLabelPairs(orgs);

  const [title, setTitle] = useState(subright != null ? subright.title : "");
  const [description, setDescription] = useState(
    subright != null ? subright.description : ""
  );
  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [textChanged, setTextChanged] = useState(false);
  const [selectedOrgsChanged, setSelectedOrgsChanged] = useState(false);

  useEffect(() => {
    if (editMode) {
      initializeSelectedOrgs();
    }
    // eslint-disable-next-line
  }, []);

  const initializeSelectedOrgs = () => {
    const associatedOrgs = subright.organizations;
    const selected = selectOptions.filter((orgOption) =>
      associatedOrgs.includes(orgOption.value.id)
    );
    setSelectedOrgs(selected);
  };

  const checkIfSelectWasEdited = (selectedOrgs) => {
    const subrightOrgs = subright.organizations;
    let selectedChanged = false;
    selectedOrgs.forEach((selectedOrg) => {
      if (!subrightOrgs.includes(selectedOrg.value.id)) {
        selectedChanged = true;
        return;
      }
    });
    selectedChanged = selectedOrgs.length !== subrightOrgs.length;

    return selectedChanged;
  };

  const checkIfTextWasEdited = (title, description) => {
    return subright.title !== title || subright.description !== description;
  };

  const onChangeTitleText = (e) => {
    const enteredTitle = e.target.value;
    if (editMode) {
      setTextChanged(checkIfTextWasEdited(enteredTitle, description));
    }
    setTitle(e.target.value);
  };

  const onChangeDescriptionText = (e) => {
    const enteredDescription = e.target.value;
    if (editMode) {
      setTextChanged(checkIfTextWasEdited(title, enteredDescription));
    }
    setDescription(e.target.value);
  };

  const onChangeSelectedOptions = (selectedOptions) => {
    if (editMode) {
      setSelectedOrgsChanged(checkIfSelectWasEdited(selectedOptions));
    }
    setSelectedOrgs(selectedOptions);
  };

  const onClickCancel = () => {
    navigate(-1);
  };

  const isValidInput = () => {
    if (title === "" || description === "" || selectedOrgs.length === 0) {
      return false;
    }
    return true;
  };

  const onClickSave = () => {
    if (!isValidInput()) {
      // TODO: Display an error
      return;
    }
    if (editMode) {
      const orgs = selectedOrgs.map((selectedOrg) => selectedOrg["value"]);
      const newSubright = FBSubrightBuilder.buildFBSubright(
        description,
        orgs,
        title,
        selectedRightCategory.id
      );
      editSubright(newSubright, subright, () => {
        navigate(-1);
      });
    } else {
      const orgs = selectedOrgs.map((selectedOrg) => selectedOrg["value"]);
      const newSubright = FBSubrightBuilder.buildFBSubright(
        description,
        orgs,
        title,
        selectedRightCategory.id
      );
      addSubright(newSubright, () => {
        navigate(-1);
      });
    }
  };

  const onClickDelete = () => {
    if (window.confirm("Are you sure you want to delete this subright?")) {
      deleteSubright(subright, () => {
        navigate(-1);
      });
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.innerContainer}>
        <p className={styles.title}>Subright Information</p>
        <div className={styles.formContainer}>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Title:</p>
            <input
              className={styles.inputStyle}
              type="text"
              value={title}
              onChange={onChangeTitleText}
            />
          </div>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Description:</p>
            <textarea
              className={styles.inputStyleArea}
              value={description}
              onChange={onChangeDescriptionText}
            />
          </div>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Orgs:</p>
            <Select
              isMulti
              placeholder="Associated Organizations..."
              value={selectedOrgs}
              onChange={onChangeSelectedOptions}
              className={styles.selectField}
              options={selectOptions}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <div className={styles.cancelButton} onClick={onClickCancel}>
              Cancel
            </div>
            {editMode ? (
              <div className={styles.deleteButton} onClick={onClickDelete}>
                Delete
              </div>
            ) : null}
            {textChanged || selectedOrgsChanged || !editMode ? (
              <div className={styles.saveButton} onClick={onClickSave}>
                Save
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditSubrightScreen;
